import { useLinkageAmount } from '../LinkageCreationContext'
import CustomButton from '../../../../../ui/CustomButton'
import { useContext, useEffect, useState } from 'react'
//import { useLinkageBusinessAPI } from '../LinkageCreationContext'
import GlobalContext from '../../../../../../../context/global-context'
import { BankAPI } from '../../../../../../../api/bancos.api'
import { Title } from '../../../../../ui'
import ResizableModal from '../../../../../ui/ResizableModal'

const InputField = ({ label, placeholder, type, value, onChange, disabled = false }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-sm font-sans
        ${disabled
          ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
          : 'focus:border-indigo-500 focus:ring-indigo-500'}
      `}
    />
  </div>
)

const TextAreaField = ({ label, value, onChange, ...props }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <textarea
      className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans'
      value={value}
      onChange={onChange}
      {...props}
    />
  </div>
)

const PagoCuotaPrestamo = ({ open, setOpen, type = 'egreso', setSwitchDate}) => {
  //const [movimientoSeleccionado] = useState(null)
    const [fecha, setFecha] = useState('')
    const [glosa, setGlosa] = useState('')
    const [monto, setMonto, bankAmountLocked] = useLinkageAmount('')
    const [rut, setRut] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    //const businessAPI = useLinkageBusinessAPI()
    const { currentBusiness } = useContext(GlobalContext)
    const [, setDataBanco] = useState({})
    const bankAPI = new BankAPI()
  
    const handleClose = () => setOpen(false)
  
    const getBanco = async () => {
        try {
          const responseBank = await bankAPI.getListBank(currentBusiness.id) 
          setDataBanco(responseBank)
        } catch (error) {
          console.error(error)
        }
      }
    
      useEffect(() => {
        getBanco()
      }, [currentBusiness])
    
    /*const handleDatos = async () => {
      const payload = {
        fecha: fecha,
        vencimiento: null,
        transaccionId: movimientoSeleccionado?.id,
        razonSocial: razonSocial || null,
        rut: rut,
        rutId: null,
        nombreComprobante: null,
        nombreComprobanteId: null,
        glosa: glosa || null, 
        respaldoId: null,
        monto: Number(monto),
      }
      try {
        ui.setLoader({ visible: true})
        const response = await businessAPI.postPagoArriendo(currentBusiness.id, payload, 'pago-cuota-prestamo')
        console.info(response)
        setSwitchDate(true)
        handleClose()
      } catch (error) {
        console.error('Error al agregar comprobante:', error.message)
      } finally {
        ui.setLoader({ visible: false})
      }
    }*/
  
    const formatMonto = (value) => {
      if (!value) return '' 
      const numericValue = value.replace(/\D/g, '')
      if (!numericValue) return ''
      return new Intl.NumberFormat('es-CL').format(numericValue)
    }
    
    const formatRut = (input) => {
      let cleaned = input.replace(/[^0-9kK]/g, '').toUpperCase()
      // Limita a 9 caracteres (8 cuerpo + 1 DV)
      if (cleaned.length > 9) cleaned = cleaned.slice(0, 9)
      const body = cleaned.slice(0, -1)
      const dv = cleaned.slice(-1)
      let formattedBody = ''
      for (let i = body.length - 1, j = 1; i >= 0; i--, j++) {
        formattedBody = body[i] + formattedBody
        if (j % 3 === 0 && i !== 0) {
          formattedBody = '.' + formattedBody
        }
      }
      if (body.length === 0) return dv
      return `${formattedBody}-${dv}`
    }
  
    useEffect(() => {
      const today = new Date().toISOString().split('T')[0]
      setFecha(today)
    }, [])
  
    return (
      <ResizableModal open={open} onClose={handleClose} 
      footer={
        <>
          <CustomButton title='CANCELAR' color='primary' className='rounded-full' onClick={handleClose} />
          <CustomButton title='GRABAR VINCULACIÓN' color='accent2' className='rounded-full' />
        </>
      }>
        <div className="mt-4">
          <div className='flex justify-between items-center mb-6'>
            <div>
              <Title className='text-3xl font-sans'>Pago Cuota Prestamo</Title>
            </div>
          </div>
          <div className="flex w-full items-start h-full p-6 bg-white rounded-lg shadow-md'">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 w-full">
              <InputField label="Folio" type="text" disabled />
              <div>
                <label className="block text-sm font-sans font-medium text-gray-700">Fecha</label>
                <input
                  type="date"
                  value={fecha}
                  onChange={(e) => setFecha(e.target.value)}
                  className="mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans"
                />
              </div>
              <InputField
                label="Contraparte"
                placeholder="Nombre"
                type="text"
                value={razonSocial}
                onChange={(e) => setRazonSocial(e.target.value)}
              />
              <InputField
                label="RUT"
                placeholder="11.111.111-1"
                type="text"
                value={rut}
                onChange={(e) => setRut(formatRut(e.target.value))}
              />
              <InputField disabled={bankAmountLocked}
                label="Monto Capital"
                placeholder="$"
                type="text"
                value={formatMonto(monto)}
                onChange={(e) => setMonto(e.target.value.replace(/[^0-9]/g, ''))}
              />
              <InputField disabled={bankAmountLocked}
                label="Monto Interes"
                placeholder="$"
                type="text"
                value={formatMonto(monto)}
                onChange={(e) => setMonto(e.target.value.replace(/[^0-9]/g, ''))}
              />
              <InputField label="Clasificación" placeholder="2-1-11-1 Otros Acreedores" type="text" disabled />
              <TextAreaField
                label="Detalle"
                placeholder="Describe en detalle la naturaleza, origen o lo que mejor describa la vinculación que vamos a crear."
                value={glosa}
                onChange={(e) => setGlosa(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ResizableModal>
    )
}

export default PagoCuotaPrestamo
